import type { FavoriteTab } from "@/providers/favorite-provider";
import styles from "./favorites-tabs.module.css";

type FavoritesTabsProps = {
  activeTab: FavoriteTab;
  onTabChange: (tab: FavoriteTab) => void;
};

function CarIcon() {
  return (
    <svg className={styles.icon} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" fill="currentColor"/>
    </svg>
  );
}

function MotoIcon() {
  return (
    <svg className={styles.icon} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" fill="currentColor"/>
    </svg>
  );
}

export function FavoritesTabs({
  activeTab,
  onTabChange,
}: Readonly<FavoritesTabsProps>) {
  return (
    <div className={styles.switcher} data-testid="favorites-tabs">
      <button
        type="button"
        className={`${styles.tab} ${activeTab === "cars" ? styles.active : ""}`}
        onClick={() => onTabChange("cars")}
        data-testid="tab-cars"
      >
        <CarIcon />
        <span>Carro</span>
      </button>
      <button
        type="button"
        className={`${styles.tab} ${activeTab === "motos" ? styles.active : ""}`}
        onClick={() => onTabChange("motos")}
        data-testid="tab-motos"
      >
        <MotoIcon />
        <span>Moto</span>
      </button>
    </div>
  );
}
